import {
  ApiNotificationItem,
  ApiTestAgentOtpResponse,
  CloseMethod,
  RegistrationTestPatient,
  TestPatient,
} from 'src/app/core/models';

export const getTestPatients = (): TestPatient[] => {
  return [
    {
      id: 10000, // called patientId as of now
      firstName: 'JOHN',
      lastName: 'SMITH',
      balance: 0,
      insuranceTypeId: 1,
      insuranceTypeName: 'Medicare',
      primaryReportGroup: 'MCR',
      numOfProviders: 1,
      numOfReorders: 2,
      numOfInsurances: 1,
      numOfAddresses: 2,
      numOfPastOrders: 1,
      hasPaymentPlan: false,
      hasRentalSchedule: true,
      reorderCards: [
        {
          orderId: 10023,
          shipmentTypeId: 60,
          shipmentTypeDesc: 'Pump and/or CGM',
          targetShipDate: '2022-04-04',
          dateOfService: '2022-04-04',
          numOfReorderItems: 2,
          numOfDaysOnHandRequiredItems: 2,
          numOfTestingFrequencyRequiredItems: 2,
          numOfPumpSiteChangeFrequencyRequiredItems: 2,
          lastProviderVisitRequired: false,
          hasMismatchingTargetShipDates: false,
          numOfNoChargeItems: 1,
          hasMissingDocumentation: false,
          numOfSetOrReservoirItems: 1,
          numOfSensorItems: 1,
          numOfTestingSupplyItems: 1,
        },
        {
          orderId: 10024,
          shipmentTypeId: 60,
          shipmentTypeDesc: 'Pump and/or CGM',
          targetShipDate: '2022-04-03',
          dateOfService: '2022-04-03',
          numOfReorderItems: 1,
          numOfDaysOnHandRequiredItems: 1,
          numOfTestingFrequencyRequiredItems: 1,
          numOfPumpSiteChangeFrequencyRequiredItems: 1,
          lastProviderVisitRequired: false,
          hasMismatchingTargetShipDates: false,
          numOfNoChargeItems: 1,
          hasMissingDocumentation: false,
          numOfSetOrReservoirItems: 1,
          numOfSensorItems: 1,
          numOfTestingSupplyItems: 1,
        },
      ],
    },
  ];
};

export const resetTestPatientPaymentMethods = () => {};

export const updateTestPatientPaymentMethods = () => {};

export const getRegistrationTestPatients = (): RegistrationTestPatient[] => [
  {
    patientId: 1,
    firstName: 'JOHN',
    lastName: 'SMITH',
    insuranceNumber: 'ABC123',
    dob: '1990-01-25',
    zipCode: '12345',
  },
  {
    patientId: 2,
    firstName: 'ELENA',
    lastName: 'HOPKINS',
    insuranceNumber: 'XYZ456',
    dob: '2005-04-15',
    zipCode: '88877',
  },
];

export const updateRegistrationTestPatientContacts = () => {};

export const testPatientNotification: ApiNotificationItem = {
  id: 123,
  priority: 10,
  closeMethod: CloseMethod.Expiration,
  externalText: 'This is a priority 10 notification (id: 123) with an expiration close method',
  externalButtonLabel1: 'Button 1',
  externalButtonLabel2: 'Button 2',
  externalCustomActionId: 'CustomActionId123',
};

export const createTestPatientNotificationMock = () => testPatientNotification;
export const setTestPatientCopayExclusion = () => {};
export const createTestAgentOtp = (): ApiTestAgentOtpResponse => ({ otp: 'abcd' });
export const setTestPatientDeductibleOverrides = () => {};
